export interface LayoutInput {
  id: string;
  start: number;
  end: number;
}

export interface LayoutSlot {
  lane: number;
  lanes: number;
}

export function layoutLanes(items: readonly LayoutInput[]): Map<string, LayoutSlot> {
  const placed = new Map<string, LayoutSlot>();
  const sorted = [...items].sort((a, b) => a.start - b.start || b.end - a.end || a.id.localeCompare(b.id));

  let cluster: { id: string; lane: number }[] = [];
  let laneEnds: number[] = [];
  let clusterEnd = -Infinity;

  const flush = () => {
    for (const member of cluster) placed.set(member.id, { lane: member.lane, lanes: laneEnds.length });
    cluster = [];
    laneEnds = [];
    clusterEnd = -Infinity;
  };

  for (const item of sorted) {
    const end = Math.max(item.end, item.start + 1);
    if (cluster.length > 0 && item.start >= clusterEnd) flush();
    let lane = laneEnds.findIndex((laneEnd) => laneEnd <= item.start);
    if (lane === -1) {
      lane = laneEnds.length;
      laneEnds.push(end);
    } else {
      laneEnds[lane] = end;
    }
    cluster.push({ id: item.id, lane });
    clusterEnd = Math.max(clusterEnd, end);
  }
  flush();

  return placed;
}

export function laneGeometry(slot: LayoutSlot, gapPct: number = 2): { startPct: number; widthPct: number } {
  const width = 100 / slot.lanes;
  const startPct = slot.lane * width;
  const widthPct = slot.lanes === 1 ? 100 : Math.max(width - gapPct, 10);
  return { startPct, widthPct };
}

export interface Interval {
  start: number;
  end: number;
}

export function rowOccupancy(rows: readonly Interval[], intervals: readonly Interval[]): number[] {
  const sorted = [...intervals].sort((a, b) => a.start - b.start);
  const counts = new Array<number>(rows.length).fill(0);
  let first = 0;
  rows.forEach((row, index) => {
    while (first < sorted.length && Math.max(sorted[first].end, sorted[first].start + 1) <= row.start) first += 1;
    for (let cursor = first; cursor < sorted.length && sorted[cursor].start < row.end; cursor += 1) {
      if (Math.max(sorted[cursor].end, sorted[cursor].start + 1) > row.start) counts[index] += 1;
    }
  });
  return counts;
}

export function stripGeometry(index: number, strips: number): { startPct: number; widthPct: number } {
  const width = 100 / Math.max(strips, 1);
  return { startPct: index * width, widthPct: width };
}
